import { tv, type VariantProps } from "tailwind-variants";

export const imageParallaxVariant = tv({
  slots: {
    base: ["w-full", "py-8", "lg:pt-15 lg:pb-20"],
    wrapper: ["container-fluid"],
    header: [
      "flex",
      "flex-col",
      "text-center",
      "gap-4 gap-10",
      "lg:max-w-2xl",
      "mx-auto",
    ],
    description: ["text-neutral-soft"],
    photos: ["flex", "flex-row", "justify-center"],
    photo: [],
    image: ["overflow-hidden"],
  },
  variants: {
    contentOrder: {
      imageContent: {
        wrapper: ["flex-col", "lg:flex-row"],
      },
      contentImage: {
        wrapper: ["flex-row-reverse", "lg:flex-col-reverse"],
      },
    },
  },
  defaultVariants: {},
});

export const imageParallaxPhotoFrameVariant = tv({
  slots: {
    frame: [
      "p-1",
      "pb-6",
      "lg:p-3",
      "lg:pb-18",
      "w-full",
      "max-w-[311px]",
      "h-auto",
      "aspect-[3/4]",
      "border",
      "border-neutral-dark-alpha/10",
      "bg-white",
      "shadow-lg",
    ],
    figure: ["relative", "w-full", "h-full", "shrink-0"],
    image: ["object-cover"],
  },
  variants: {},
  defaultVariants: {},
});

export type ImageParallaxVariantProps = VariantProps<typeof imageParallaxVariant>;
export type ImageParallaxReturnVariantProps = ReturnType<typeof imageParallaxVariant>;
